<template>
	<div class="report-left panel">
		<div class="panel-content">
		<div class="panel-title">趋势图</div>
			<type-select></type-select>
			<div id="myChart" :style="{width:'100%',height:'340px'}" ref="myEchart"></div>
		</div>
	</div>
</template>

<script>
import TypeSelect from './TypeSelect'
import echarts from 'echarts'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
	name: '',
	data () {
		return {
			// curType: 'pv_count',
		}
	},
	computed: {
		...mapState('siteStas', ['recentStasData', 'datePickerData', 'curType', 'datePickerData']),
		...mapGetters('siteStas', ['getXAxisData', 'getSeriesData', 'getSeriesName']),
	},
	mounted () {
		this.chart = echarts.init(this.$refs.myEchart)
	},
	components: {
		TypeSelect
	},
	watch: {
		recentStasData (newVal, oldVal) {
			this.chart.setOption(this.getOption())
		},
		curType (newVal, oldVal) {
			this.chart.setOption(this.getOption())
		}
	},
	methods: {
		getOption () {
			let option = {
				color: '#b9dcfd',
				animation: true,
				tooltip: {
					trigger: 'axis'
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: this.getXAxisData
				},
				yAxis: {
					type: 'value'
				},
				series: [{
					data: this.getSeriesData,
					areaStyle: {},
					name: this.getSeriesName,
					type: 'line'
				}]
			}
			if (this.curType === 'bounce_ratio') {
				option.tooltip.formatter = '{b}<br>{a0}: {c}%'
			} else {
				option.tooltip.formatter = undefined
			}
			return option
		}
	}
}
</script>

<style lang="scss" scoped>
.panel-title {
	padding-left:15px;
    color: #373D45;
	font-weight: bolder;
	line-height: 15px;
	border-left: 4px solid $colorA;
	margin-bottom: 40px;
}
.report-left {
    min-height: 415px;
    width: 50%;
    float: left;
}
.panel-content{
	width:63.7%;
	min-width: 535px;
	margin: 0 auto;
}
.chart {
    display: block;
    height: 300px;
    text-align: center;
}
.echart {
    display: block;
}
</style>
